import DropdownTriggerButton from './DropdownTriggerButton';
import DropdownTriggerContent from './DropdownTriggerContent';

const DropdownTrigger = {
  Button: DropdownTriggerButton,
  Content: DropdownTriggerContent,
};

export default DropdownTrigger;
